<template>
    <div
        v-if="productPlan"
        :key="productPlan.name"
        class="product__item-grid-tile product__item-grid-tile-hosting"
        :class="{ 'is-selected': orderVpsState({ name: productPlan.name, domain: domain.domain }) }"
    >
        <div v-if="productPlan.marketing" class="product__item__grid-tile-highlight">
            {{ productPlan.marketing }}
        </div>
        <div class="product__item-grid-tile-header">
            <div class="u-flex-between">
                <h3 class="gamma | product__item-grid-tile-title">{{ productPlan.name }}</h3>
                <span>
                    <price-display :price="monthPrice" />
                    {{ trans('order.per-month') }}
                </span>
            </div>
            <p class="product__item-grid-tile-subtitle p--flush">
                {{ productPlan.description }}
            </p>
        </div>

        <div class="product__item-grid-tile-list | clearfix">
            <product-descriptors v-if="productPlan.descriptors" :descriptors="productPlan.descriptors.main" />
        </div>

        <div class="product__item-grid-tile-list | u-margin-bottom clearfix">
            <product-descriptors
                v-if="productPlan.descriptors"
                :descriptors="productPlan.descriptors.small"
                :small="true"
            />
        </div>

        <div class="product__item-grid-tile-button">
            <div class="u-text-center">
                <button
                    :class="{
                        'btn--ghost': !orderVpsState({ name: productPlan.name, domain: domain.domain }),
                        'btn--ghost-selected': orderVpsState({ name: productPlan.name, domain: domain.domain })
                    }"
                    @click="
                        switchVps({
                            name: productPlan.name,
                            domain: domain.domain,
                            status: displayPriceType,
                            price: productPrice,
                            gross_price: grossProductPrice,
                            period: defaultPeriod
                        })
                    "
                    type="button"
                    dusk="add-vps-button"
                    class="btn | u-full-width"
                >
                    <span v-if="!orderVpsState({ name: productPlan.name, domain: domain.domain })">{{
                        trans('order.select')
                    }}</span>
                    <span v-else>{{ trans('order.chosen') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PriceDisplay from '@/components/Price/PriceDisplay.vue';
import ProductDescriptors from '../ProductDescriptors.vue';
import productMixin from '../../mixins/product.js';

export default {
    components: {
        ProductDescriptors,
        PriceDisplay
    },
    mixins: [productMixin],
    props: {
        productPlan: {
            type: Object,
            required: true,
            default: () => {}
        },
        domain: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            productType: 'vps'
        };
    },
    computed: {
        ...mapGetters({
            orderVpsState: 'order/vpsState'
        })
    },
    methods: {
        ...mapActions({
            switchVps: 'order/switchVps'
        })
    }
};
</script>
